export const kolVsLsgMyTeamsList = [
  {
    matchId: '628240bd6d0713b9cf82d75c',
    userId: '5fd32b93eaf661ea51eae8af',
    score: -5,
    username: 'RajasthanRoyals',
    firstname: 'Rajasthan',
    lastname: 'Royals',
    middlename: null,
    id: '6284d55184ba3b001dc014b9'
  }
];

export const punVsDcMyTeamsList = [
  {
    matchId: '627fbf7d6d0713b9cf388229',
    userId: '5fd32b93eaf661ea51eae8af',
    score: 5,
    username: 'RajasthanRoyals',
    firstname: 'Rajasthan',
    lastname: 'Royals',
    middlename: null,
    id: '628242eb92265b002053978b'
  }
];

export const nzVsPakYesNoMyTeamsList = [
  {
    id: '63c1095dd1aa43001dca66eb',
    score: 5,
    matchId: '63be86840901e17d0f43117e',
    userId: '5fd32b93eaf661ea51eae8af',
    username: 'RajasthanRoyals',
    firstname: 'Rajasthan',
    lastname: 'Royals',
    middlename: null
  }
];

export const indVsZimYesNoMyTeamsList = [
  {
    _id: '630086b94e80da001d0d7beb',
    matchId: '62fdf2711f7aacc4e352a767',
    userId: '5fd32b93eaf661ea51eae8af',
    username: 'RajasthanRoyals',
    firstname: 'Rajasthan',
    lastname: 'Royals',
    middlename: null,
    score: 10
  }
];

export const slVsAfgYesNoMyTeamList = [
  {
    _id: '622c42a5ff867e001dbb43cb',
    matchId: '6225783d17d940379f6d67d1',
    userId: '601cd58656c4dd5b565191e9',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Verma',
    middlename: null,
    score: 5
  }
];
export const indVsSaYesNoMyTeamsList = [
  {
    _id: '6339908769b991001fa1add6',
    matchId: '63344fdc258445b807480bf7',
    userId: '5fd32b93eaf661ea51eae8af',
    username: 'RajasthanRoyals',
    firstname: 'Rajasthan',
    lastname: 'Royals',
    middlename: null,
    score: 10
  }
];
